import {
  effectiveColor,
  FALLBACK_PALETTE_COLOR,
  paletteHex,
  type LiveProject,
  type ProjectsById,
} from '@wiztime/core';

/**
 * The display colour (hex) of a project: a child project that follows its parent's colour
 * (`inheritColor`) takes the parent's. Every place that paints a project (blocks, tiles, chips,
 * bars, print) resolves the colour through this function. A missing project gets the fallback colour.
 */
export function projectHex(project: LiveProject | undefined, byId: ProjectsById): string {
  return paletteHex(project === undefined ? FALLBACK_PALETTE_COLOR : effectiveColor(project, byId));
}

/** `projectHex` for a project id; unknown ids get the fallback colour. */
export function projectHexById(projectId: string, byId: ProjectsById): string {
  return projectHex(byId.get(projectId), byId);
}
